import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getconfiguracion, configuracion } from "../../constants/config";
import { useNavigate } from "react-router-dom";

const toBool = (val) => {
  const result = val === 1 || val === "1" || val === true || val === "true" || val === "on";
  // console.log("toBool:", val, "=>", result);
  return result;
};

const toStrBool = (val) => (val ? "1" : "0");

const idEmpresa = process.env.REACT_APP_DB_EMPRESA || "01";

const Configuracion = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    empresa: idEmpresa,
    login: false,
    vista: "table",
    carousel_home: false,
    carousel_mueve: false,
    con_sin_precio: false,
    con_sin_stock: false,
    mostrar_grupos: false,
    mostrar_marcas: false,
    mostrar_tipos: false,
    muestra_cuadrante: false,
    genera_presupuesto: false,
    registrarse: false,
    genera_presupuesto: false,
    horario: "",
    id_canal: "",
    nosotros: "",
    url_facebook: "",
    url_instagram: "",   // corregido typo
    url_linkedin: "",
    url_tiktok: "",
    url_twitter: "",
    url_youtube: "",
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await getconfiguracion();
        console.log(res);

        // Verificamos que no haya error y que data exista
        if (res && !res.error && res.data) {
          const data = res.data; // 👈 acá extraemos la verdadera config

          setFormData({
            empresa: idEmpresa,
            login: toBool(data.login),
            vista: data.vista || "table",
            carousel_home: toBool(data.carousel_home),
            carousel_mueve: toBool(data.carousel_mueve),
            con_sin_precio: toBool(data.con_sin_precio),
            con_sin_stock: toBool(data.con_sin_stock),
            mostrar_grupos: toBool(data.mostrar_grupos),
            mostrar_marcas: toBool(data.mostrar_marcas),
            mostrar_tipos: toBool(data.mostrar_tipos),
            muestra_cuadrante: toBool(data.muestra_cuadrante),
            genera_presupuesto: toBool(data.genera_presupuesto),
            registrarse: toBool(data.registrarse),
            horario: data.horario || "",
            id_canal: data.id_canal || "",
            nosotros: data.nosotros || "",
            url_facebook: data.url_facebook || "",
            url_instagram: data.url_instagram || "",
            url_linkedin: data.url_linkedin || "",
            url_tiktok: data.url_tiktok || "",
            url_twitter: data.url_twitter || "",
            url_youtube: data.url_youtube || "",
            filtra_palabras: data.filtra_palabras || "",
          });
        }
      } catch (error) {
        Swal.fire("Error", "No se pudo cargar la configuración", "error");
      }
    };

    fetchConfig();
  }, []);


  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = {
      empresa: idEmpresa,
      login: toStrBool(formData.login),
      vista: formData.vista,
      carousel_home: toStrBool(formData.carousel_home),
      carousel_mueve: toStrBool(formData.carousel_mueve),
      con_sin_precio: toStrBool(formData.con_sin_precio),
      con_sin_stock: toStrBool(formData.con_sin_stock),
      mostrar_grupos: toStrBool(formData.mostrar_grupos),
      mostrar_marcas: toStrBool(formData.mostrar_marcas),
      mostrar_tipos: toStrBool(formData.mostrar_tipos),
      muestra_cuadrante: toStrBool(formData.muestra_cuadrante),
      genera_presupuesto: toStrBool(formData.genera_presupuesto),
      registrarse: toStrBool(formData.registrarse),
      horario: formData.horario,
      id_canal: formData.id_canal,
      nosotros: formData.nosotros,
      url_facebook: formData.url_facebook,
      url_instagram: formData.url_instagram,
      url_linkedin: formData.url_linkedin,
      url_tiktok: formData.url_tiktok,
      url_twitter: formData.url_twitter,
      url_youtube: formData.url_youtube,
      filtra_palabras: formData.filtra_palabras,
    };

    try {
      const res = await configuracion(dataToSend);
      if (res.status) {
        Swal.fire("¡Listo!", res.message, "success").then(() => {
          navigate("/"); // 👈 Redirección al Home
        });
      } else {
        Swal.fire("Error", res.message || "Error al guardar configuración", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Error al guardar configuración", "error");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Configuración del eCommerce</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        {/* Select Vista */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className="block font-semibold">Vista</label>
            <select
              name="vista"
              value={formData.vista}
              onChange={handleChange}
              className="w-full border p-2"
            >
              <option value="table">Tabla</option>
              <option value="grid">Grilla</option>
            </select>
          </div>
          {/* Podés agregar más divs acá para que se acomoden en las columnas */}
        </div>


        {/* ✅ Todos los CHECKBOXES */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {[
            "login",
            "carousel_home",
            "carousel_mueve",
            "con_sin_precio",
            "con_sin_stock",
            "mostrar_grupos",
            "mostrar_marcas",
            "mostrar_tipos",
            "muestra_cuadrante",
            "genera_presupuesto",
            "registrarse",
          ].map((field) => (
            <div key={field} className="flex items-center justify-center gap-2 col-span-1">
              <input
                type="checkbox"
                name={field}
                checked={formData[field]}
                onChange={handleChange}
                id={field}
              />
              <label htmlFor={field} className="capitalize">
                {field
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
              </label>
            </div>
          ))}
        </div>
          <div className="col-span-full">
            <label className="block font-semibold">
              Filtra Palabras
            </label>
            <textarea
              name="filtra_palabras"
              value={formData.filtra_palabras}
              onChange={handleChange}
              className="w-full border p-2 min-h-[150px]"
              rows={6}
            />
          </div>

        {/* 📝 Todos los INPUTS DE TEXTO */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="col-span-full">
            <label className="block font-semibold">
              Nosotros
            </label>
            <textarea
              name="nosotros"
              value={formData.nosotros}
              onChange={handleChange}
              className="w-full border p-2 min-h-[150px]"
              rows={6}
            />
          </div>
          {[
            "horario",
            "id_canal",
            "url_facebook",
            "url_instagram",
            "url_linkedin",
            "url_tiktok",
            "url_twitter",
            "url_youtube",
          ].map((field) => (
            <div key={field}>
              <label className="block font-semibold">
                {field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
              </label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                className="w-full border p-2"
              />
            </div>
          ))}

        </div>

        {/* BOTÓN */}
        <div className="col-span-full">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Guardar Configuración
          </button>
        </div>
      </form>

    </div>
  );
};

export default Configuracion;
